// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExpiredWorkspaces_wrapper__O0QFN","warning":"ExpiredWorkspaces_warning__zqc1a"};